// extracted by mini-css-extract-plugin
var _1 = "TopicIcon-module__animateUploadProgressBarWidth--Mrb4H";
var _2 = "TopicIcon-module__animatedBackground--6wU2q";
var _3 = "TopicIcon-module__container--y0Ohw";
var _4 = "TopicIcon-module__icon--kqqHs";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "icon" }
